import Env from '../base/env'
import { gsap, Cubic, Power2, Power3 } from 'gsap'

export default class MainTransition
{
    constructor()
    {
        this.view = Env.$mainTransition
        this.settings = { easing : Cubic.easeInOut , duration : .6 }
        this.direction = false
        this.status = false
        this.setDirection(-1)
    }

    getStatus()
    {
        return this.status
    }



    in(funcStart='',funcComplete='')
    {
        let timeline = gsap.timeline({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'in'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add([
            gsap.fromTo(Env.$mainTransitionProgress , 1, { scaleX : 0 , transformOrigin : 'left top' } , { scaleX : 1 , ease : Power3.easeInOut }),
            gsap.fromTo(this.view , this.settings.duration,
                {
                    autoAlpha : 0
                },
                {
                    autoAlpha : 1,
                    ease: this.settings.easing,
                    delay: 0,
                }
            )
        ])
    }

    out(funcStart='',funcComplete='')
    {
        let timeline = gsap.timeline({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'out'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })
        const goTo = (this.direction > 0)?'100%':'-100%'
        timeline.add([
            gsap.fromTo(Env.$mainTransitionProgress , 1 , { transformOrigin : 'right top' } , { scaleX : 0 , ease : Power3.easeInOut }),
            gsap.fromTo(this.view , 1,
                {
                    autoAlpha : 1,
                },
                {
                    autoAlpha : 0,
                    ease: this.settings.easing,
                    delay: 0,
                }
            )
        ],'+=.1')
    }

    setDirection(value)
    {
        this.direction = value
    }
}
